// extracted by mini-css-extract-plugin
export default {"container":"global-styles_container__IhQDJ"};